import { render, staticRenderFns } from "./teacherIndex.vue?vue&type=template&id=71b6554a&scoped=true"
import script from "./teacherIndex.vue?vue&type=script&lang=js"
export * from "./teacherIndex.vue?vue&type=script&lang=js"
import style0 from "./teacherIndex.vue?vue&type=style&index=0&id=71b6554a&prod&scoped=true&lang=scss"
import style1 from "./teacherIndex.vue?vue&type=style&index=1&id=71b6554a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6554a",
  null
  
)

export default component.exports